import * as React from 'react';
import { arrayToClass } from '../../../../utilities/helper-fuctions';
import { InputWrapper } from './input-wrapper';

export class Textarea extends InputWrapper<any, any> {
	public renderInput(): any {
		const classes = arrayToClass([
			'w-100',
			this.props.inputClasses ? this.props.inputClasses : '',
			this.props.disabled
				? 'palette--bc-neutral-2 palette--bgc-neutral-2'
				: this.props?.error
				? 'palette--bc-red-2 palette--bgc-neutral-1'
				: 'palette--bc-neutral-4 palette--bgc-neutral-1',
		]);

		return (
			<textarea
				autoFocus={this.props.autoFocus || false}
				value={this.state.value as any}
				onChange={(event) => this.handleChange(event)}
				disabled={this.props.disabled || false}
				className={classes}
				rows={this.props?.rows}
				onBlur={(e) => this.props.onBlur && this.props.onBlur(e)}
				onFocus={(e) => this.props.onFocus && this.props.onFocus(e)}
				{...this.props?.extras}
			/>
		);
	}
}
